import { render } from "./SecureUploadHeader.vue?vue&type=template&id=783f09ea"
import script from "./SecureUploadHeader.vue?vue&type=script&lang=js"
export * from "./SecureUploadHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__